import { Grid, styled } from "@mui/material";

export const ErrorContainer = styled(Grid)(({ theme }) => ({
  color: theme.palette.error,
  fontWeight: "bold",
  fontSize: "17px",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center"
}));
